<template>
  <c-panel caption="会員情報">
    <template>
      <c-panel-content caption="氏名">
        <span>{{user.profile.familyName}} {{user.profile.givenName}}</span>
      </c-panel-content>

      <c-panel-content caption="連絡先">
        <span>{{user.profile.phone}}</span>
      </c-panel-content>

      <c-panel-content v-if="env.license" caption="免許証有効期限">
        <div :class="licenseColor">{{user.license.expire | timeformat('Y / m / d') }}</div>

        <template v-if="licenseStatus === 'warn'">
          <c-helper-text warn>有効期限が近づいています</c-helper-text>
        </template>

        <template v-else-if="licenseStatus === 'expired'">
          <c-helper-text error>有効期限を過ぎています</c-helper-text>
        </template>
      </c-panel-content>
    </template>

    <template #actions>
      <c-panel-action
        caption="会員情報を変更する"
        :to="{ name: 'my/profile' }"
      />
      <c-panel-action
        v-if="env.license"
        caption="免許証情報を変更する"
        :to="{ name: 'my/license' }"
      />
    </template>
  </c-panel>
</template>

<script>
import base from './base'
import * as time from '@/libs/time'

import CHelperText from '@/components/CHelperText'

export default {
  name: 'CProfilePanel',
  mixins: [
    base
  ],
  components: {
    CHelperText
  },
  props: {
    env: {
      type: Object,
      required: true
    }
  },
  computed: {
    licenseStatus () {
      const today = time.today()

      // 警告する日付: 1ヶ月前
      const warnDate = time.clone(today)
      warnDate.setMonth(warnDate.getMonth() + 1)

      // 期限切れとする日付: 今日
      const expiredDate = time.clone(today)

      // 日付文字列にする
      const warn = time.format('Y-m-d', warnDate)
      const expired = time.format('Y-m-d', expiredDate)

      if (this.user.license.expire < expired) {
        return 'expired'
      } else if (this.user.license.expire < warn) {
        return 'warn'
      }
      return 'ok'
    },

    licenseColor () {
      switch (this.licenseStatus) {
        case 'warn': return 'warning--text'
        case 'expired': return 'error--text'
      }
      return ''
    }
  }
}
</script>
